/* eslint-disable @typescript-eslint/no-explicit-any */

import { useState, useCallback } from 'react';
import { css } from '@linaria/core';
import { noop } from 'utils/fp';
import { Slider } from 'components/Slider';
import { Input } from 'components/Input';
import { IconTrash } from 'components/Icons';
import { MultiSelect } from 'react-multi-select-component';
import { Option } from 'react-multi-select-component/dist/types/lib/interfaces';
import { TrashButtonContainer, TrashButtonCell, SliderContainer, Container, MultiSelectContainer, ConceptListContainer, ItemLabelContainer, ItemContainer } from './SelectConceptList.styles';
import { handleConceptSelection, removeKey } from './utils';
const zIndex100 = "odules__Models__components__ModelForm__components__FormComponentRenderer__FormComponents__SelectConceptModal__SelectConceptList_tsx-zIndex100-z12yxnj8";
interface ItemProps {
  item: Option;
  defaultValue: number;
  onChangeValue: (k: string, v: number) => void;
  onDeleteConcept: (name: string) => void;
  showThreshold?: boolean;
}
const SelectConceptListItem = ({
  item,
  defaultValue,
  onChangeValue: onChangeValueClick,
  onDeleteConcept,
  showThreshold = false
}: ItemProps): JSX.Element => {
  const [value, setValue] = useState(defaultValue);
  const onChangeValue = useCallback(v => {
    const newValue = Number(v);
    setValue(newValue);
    onChangeValueClick(item.label, newValue);
  }, []);
  return <div className={ItemContainer}>
      <div className={ItemLabelContainer}>{item.label}</div>
      {showThreshold && <div className={SliderContainer}>
          <Slider min={0} max={1} step={0.05} onChange={onChangeValue} value={value} />
          <div>
            <Input style={{
          background: '#fff',
          border: '#efefef 2px solid'
        }} placeholder="Concept threshold" value={value} onChange={e => onChangeValue(e.target.value)} />
          </div>
        </div>}
      <div className={TrashButtonCell}>
        <div role="button" onKeyDown={noop} tabIndex={0} className={TrashButtonContainer} onClick={() => onDeleteConcept(item.label)} data-testid="delete-concept">
          <IconTrash size={20} color="#aeaeae" />
        </div>
      </div>
    </div>;
};
interface SelectConceptListProps {
  selectedModelConcepts?: CF.API.Concept[];
  conceptsValues: Record<string, string | number>;
  setConceptsValues: (oldValue: unknown) => unknown;
  showThreshold?: boolean;
}
const SelectConceptList = ({
  selectedModelConcepts,
  conceptsValues,
  setConceptsValues,
  showThreshold = false
}: SelectConceptListProps): JSX.Element => {
  const [selectedConcepts, setSelectedConcepts] = useState<Option[]>(Object.keys(conceptsValues).map(name => ({
    value: name,
    label: name
  })));
  const onDeleteConcept = useCallback((k: string): void => {
    setConceptsValues(removeKey(k));
    setSelectedConcepts((oldValue: any) => {
      const idx = oldValue.findIndex(({
        value
      }: any) => value === k);
      const newArr = [...oldValue];
      newArr.splice(idx, 1);
      return newArr;
    });
  }, [setConceptsValues, setSelectedConcepts]);
  const onConceptChange = useCallback((k: string, v: number): void => {
    setConceptsValues((oldValue: any) => ({
      ...oldValue,
      [k]: v
    }));
  }, [setConceptsValues]);
  const onSetSelectedConcepts = useCallback((newSelectedConcepts: Option[]) => {
    setConceptsValues(handleConceptSelection(newSelectedConcepts));
    setSelectedConcepts(newSelectedConcepts);
  }, [setConceptsValues]);
  return <div className={Container}>
      <div className={MultiSelectContainer}>
        <div>
          <MultiSelect value={selectedConcepts} options={selectedModelConcepts?.map(({
          name,
          id
        }) => ({
          value: id,
          label: name
        })) || []} onChange={onSetSelectedConcepts} labelledBy="Select" className={zIndex100} />
        </div>
      </div>
      <div className={ConceptListContainer}>
        <div>
          {selectedConcepts.map((c: any) => <SelectConceptListItem key={c.label} showThreshold={showThreshold} item={c} defaultValue={Number(conceptsValues[c.label] || '0')} onChangeValue={(k, v) => {
          onConceptChange(k, v);
        }} onDeleteConcept={onDeleteConcept} />)}
        </div>
      </div>
    </div>;
};
export default SelectConceptList;

require("./SelectConceptList.linaria.module.css!=!../../../../../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./SelectConceptList.tsx");